<script>
import reportOrderStatus from '@constants/reportOrderStatus'
import products from '@constants/products'
import constant from '@constants/constant.json'

export default {
  components: {
    SimpleList: () => import('./SimpleList.vue'),
  },
  props: {
    controlRowSelection: { type: Boolean, default: false },
    showNew: {
      type: Boolean,
      default: false,
    },
    commands: {
      type: Array,
      default: () => [],
    },
    subtitle: {
      type: String,
      default: '',
    },
    totalRows: {
      type: Number,
      default: 0,
    },
    routePath: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    perPage: {
      type: Number,
      default: 0,
    },
    currentPage: {
      type: Number,
      default: 0,
    },
    action: {
      type: String,
      default: '',
    },
    dataTableSelectable: {
      type: Boolean,
      default: false,
    },
    headeTitle: {
      type: String,
      default: '',
    },
    showEye: {
      type: Boolean,
      default: false,
    },
    showEnvelope: {
      type: Boolean,
      default: false,
    },
    showEdit: {
      type: Boolean,
      default: false,
    },
    showdelete: {
      type: Boolean,
      default: false,
    },
    showLink: {
      type: Boolean,
      default: false,
    },
    showCopy: {
      type: Boolean,
      default: false,
    },
    showStatus: {
      type: Boolean,
      default: false,
    },
    showdatatablefooter: {
      type: Boolean,
      default: false,
    },
    selectedTablePageNumber: {
      type: Number,
      default: 1,
    },
    showDollar: {
      type: Boolean,
      default: false,
    },
    callbackFunc: {
      type: Function,
      default: () => 1,
    },
    showInfo: {
      type: Boolean,
      default: false,
    },
    isSupportAgent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      controlRowSelectEvent: false, // used to control emitting of onRowSelected event
      selAllText: 'Select All',
      selectAll: false,
      pageSize: this.perPage,
      selectedPage: this.currentPage,
      customizeUrl: '',
      selected: '',
      selectedOption: null,
      statusId: reportOrderStatus.completed,
      floodProductId: products.FloodReport,
      FloodReportInHouse: products.FloodReportInHouse,
      LiensandJudgementID: products.LiensAndJudgmentsReport,
      orderStatus: reportOrderStatus,
      multiselected: [],
      InvoiceProducts: constant.InvoiceProductIds,
      statusType: constant.OrderStatus,
      downloadReportProduct: constant.downloadProductReport,
    }
  },
  computed: {
    pageFrom: {
      get: function() {
        return Math.min(((this.currentPage - 1) * this.pageSize) + 1, this.totalRows);
      },
    },
    pageTo: {
      get: function() {
        return Math.min(this.pageSize * this.currentPage, this.totalRows);
      },
      set: function() {},
    },
    entryLabel() {
      return 'records' // this.totalRows > 1 ? 'records' : 'record'
    },
    commandData() {
      return this.showNew
    },
  },
  watch: {
    currentPage(val) {
      this.selectedPage = val
    },
  },
  methods: {
    toggleSelectAll() {
      this.selectAll = !this.selectAll
      this.selectAllRows(this.selectAll)
    },
    selectAllRows(val) {
      if (val) {
        this.$refs.selectableTable.selectAllRows()
      } else {
        this.$refs.selectableTable.clearSelected()
      }
    },
    getReportStatusId(key) {
      return reportOrderStatus[key]
    },
    costForBorrowerReportClicked() {
      if (this.callbackFunc) {
        this.callbackFunc()
      }
    },
    info(item, index, button) {
      this.$emit('showAcitivityModal', item, index, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    editStudent(id) {
      this.dialog = true
      this.editedSid = id
    },
    rowPerPageCount(perPageChange) {
      this.$emit('rowPerPageChange', perPageChange)
    },
    paginationEvent(currentPage) {
      this.$emit('paginationEvent', currentPage)
    },
    onClickEdit(editindex) {
      if (editindex.actionRadio) {
        this.selected = editindex.actionRadio.value
      }
      this.$emit('onClickEditEvent', editindex)
    },
    viewCustomers(rowItem) {
      this.$emit('onViewCustomersEvent', rowItem)
    },
    onClickDocumentName(docIndex) {
      this.$emit('onClickDocumentName', docIndex)
    },
    onClickDelete(deleteindex) {
      if (deleteindex.actionRadio) {
        this.selected = deleteindex.actionRadio.value
      }
      this.$emit('onClickDeleteEvent', deleteindex)
    },
    onClickCopy(index) {
      this.$emit('onClickCopy', index)
    },
    sortingChanged(ctx) {
      this.$emit('sortingChanged', ctx)
    },
    onClickEmail(envelope) {
      this.$emit('onClickEnevelopeEvent', envelope)
    },
    onClickUnlock(lock) {
      this.$emit('onClickUnlockEvent', lock)
    },
    onClickFolder(link) {
      this.$emit('onClickFolderEvent', link)
    },
    onCopyLink(link) {
      this.$emit('onClickLInkEvent', link)
    },
    onClickSave(saveUrl) {
      this.$emit('onClickSaveUrl', saveUrl)
    },
    onClickReset(event) {
      this.customizeUrl = ''
    },
    onClickOrderNumberLink(rowIndex) {
      this.$emit('onClickOrderNumberLink', rowIndex)
    },
    onClickrequestNumberLink(rowIndex) {
      this.$emit('onClickrequestNumberLink', rowIndex)
    },
    onClickPendingStatus(item, rowIndex) {
      this.$emit('onClickPendingStatus', { row: item, index: rowIndex })
    },
    onClickAssignPackage(items) {
      this.$emit('onAssignPackages', items)
    },
    onClickAssignConnection(items) {
      this.$emit('onAssignConnection', items)
    },
    onRowSelected(items) {
      this.selectAll =
        this.items.length || items.length
          ? this.items.length === items.length
          : false

      if (this.controlRowSelection) {
        let selected = items.filter((s) => s.disableSelect)
        selected.forEach((element) => {
          let itemIndex = this.items.indexOf(element)
          this.controlRowSelectEvent = true
          this.$refs.selectableTable.unselectRow(itemIndex)
        })

        selected = items.filter((s) => !s.disableSelect)
        this.multiselected = selected

        if (!this.controlRowSelectEvent) this.$emit('onRowSelected', selected)
        this.controlRowSelectEvent = false
      } else {
        this.multiselected = items
        this.$emit('onRowSelected', items)
      }
    },
    onTogglePackageStatus(items) {
      this.$emit('onTogglePackageStatus', items)
    },
    onToggleBureauStatus(items) {
      this.$emit('onToggleBureauStatus', items)
    },
    onReverifyOrderVoe(items) {
      this.$emit('reverifyOrderVoe', items)
    },
    onRefreshOrderVoe(items) {
      this.$emit('refreshOrderVoe', items)
    },
    viewPdfForOrderVoe(items) {
      this.$emit('viewPdfForOrderVoe', items)
    },
    onClickDollarSign(items) {
      this.$emit('generateInvoice', items)
    },
    onClickRefItem(rowItem) {
      this.$emit('onClickRefItem', rowItem)
    },
    onClickDownload(index, item) {
      this.$emit('downloadReport', index, item)
    },
    getSelectedRecords() {
      return this.multiselected
    },
    onClickResetAccount(editindex) {
      this.$emit('onClickResetAccountEvent', editindex)
    },
  },
}
</script>

<template>
  <div class="px-1 py-2">
    <b-row class=" my-2">
      <b-col cols="auto">
        <span v-if="subtitle" :class="$style.semiBold">{{ subtitle }}</span>
      </b-col>
      <b-col cols="auto" class="ml-auto">
        <div v-if="!commandData" class="d-inline">
          <template v-for="(command, ci) in commands">
            <div
              v-if="command.isChoice"
              :key="command.event"
              class="w-auto d-inline-block"
            >
              <b-select
                v-model="command.selected"
                :options="command.choices"
                size="sm"
                dense
                class="custom-select custom-select-sm"
                @change="
                  () => $emit('onCommandEvent', command.event, command.selected)
                "
              />
            </div>
            <BaseEButton
              v-else
              :id="`tooltip-target-id-${ci}`"
              :key="command.event"
              :icon="command.icon"
              variant="icon"
              dense
              :disabled="
                command.requiresSelect
                  ? command.selectFn
                    ? command.selectFn(multiselected)
                    : multiselected.length < 1
                  : false
              "
              @click="() => $emit('onCommandEvent', command.event)"
            >
              {{ command.text }}
            </BaseEButton>
          </template>
        </div>
        <div :class="$style.statusFont" class="ml-4 p-1 d-inline">Show</div>
        <b-form-select
          v-model="pageSize"
          :options="options"
          size="sm"
          class="w-auto d-inline"
          @change.native="rowPerPageCount($event.target.value)"
        />
      </b-col>
    </b-row>
    <template>
      <div v-for="(command, ci) in commands" :key="command.tooltip">
        <div v-if="command.tooltip">
          <b-tooltip :target="`tooltip-target-id-${ci}`" triggers="hover">
            {{ command.tooltip }}
          </b-tooltip>
        </div>
      </div>
    </template>
    <div class="shadow table-responsive bg-white pb-1">
      <b-table
        ref="selectableTable"
        bordered
        striped
        hover
        small
        :items="items"
        :fields="fields"
        :selectable="dataTableSelectable"
        :per-page="pageSize"
        :current-page="
          $route.name === 'serviceProviders'
            ? currentPage
            : selectedTablePageNumber
        "
        :class="{ 'mb-0': items.length === 0 }"
        @sort-changed="sortingChanged"
        @row-selected="onRowSelected"
      >
        <template v-slot:head(customselect)="">
          <span class="hover-hand" @click="toggleSelectAll">
            {{ selectAll ? '&#x2611;' : '&#11036;' }} {{ selAllText }}
          </span>
        </template>
        <template v-slot:cell(customselect)="{ rowSelected }">
          <BaseIcon v-if="rowSelected" name="check" />
          <BaseIcon v-else name="check" class="muted" style="color: #dedede" />
        </template>

        <!-- Example scoped slot for select state illustrative purposes -->
        <template v-slot:cell(multiselected)="{ rowSelected }">
          <template v-if="rowSelected">
            <span aria-hidden="true">&#9745;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true" style="font-size:20px;">&#9744;</span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>
        <!-- To display the HyperLink for Order# column based on showLink value -->
        <template v-slot:cell(requestNumber)="rowItem">
          <b-link
            v-if="showLink"
            @click.prevent="onClickrequestNumberLink(rowItem.index)"
          >
            {{ rowItem.value }}
          </b-link>
          <template v-else>
            {{ rowItem.value }}
          </template>
        </template>
        <template v-slot:cell(alertId)="rowItem">
          <div>
            <b-link @click.prevent="onClickOrderNumberLink(rowItem.index)">
              {{ rowItem.item.alertId }}
            </b-link>
          </div>
        </template>

        <template v-slot:cell(orderNumber)="rowItem">
          <div>
            <div
              v-if="
                rowItem.item.productId === FloodReportInHouse &&
                  rowItem.item.statusId === orderStatus.new
              "
            >
              {{ rowItem.item.orderId }}
            </div>
            <div v-else-if="rowItem.item.productId === LiensandJudgementID">
              <b-link
                v-if="
                  getReportStatusId(rowItem.item.status) ===
                    orderStatus.completed
                "
                v-b-tooltip.hover
                :title="rowItem.item.orderReferenceId"
                @click.prevent="onClickOrderNumberLink(rowItem.index)"
              >
                {{ rowItem.item.orderId }}
              </b-link>
              <div
                v-else
                v-b-tooltip.hover
                :title="rowItem.item.orderReferenceId"
              >
                {{ rowItem.item.orderId }}
              </div>
            </div>
            <div v-else>
              <b-link @click.prevent="onClickOrderNumberLink(rowItem.index)">
                {{ rowItem.item.orderId }}
              </b-link>
            </div>
          </div>
        </template>

        <template v-slot:cell(isActive)="rowstatus">
          <div>
            <span v-if="rowstatus.value === true">
              <BaseIcon
                noninteractive
                name="circle"
                :class="$style.statusSuccess"
              />
            </span>
            <span v-else>
              <BaseIcon
                noninteractive
                name="circle"
                :class="$style.statusFail"
              />
            </span>
          </div>
        </template>
        <template v-slot:cell(userInfo)="rowstatus">
          <div>
            <span v-if="rowstatus.value === true">
              <BaseIcon
                noninteractive
                name="circle"
                :class="$style.statusSuccess"
              />
            </span>
            <span v-else>
              <BaseIcon
                noninteractive
                name="circle"
                :class="$style.statusFail"
              />
            </span>
          </div>
        </template>

        <template v-slot:cell(LoanOfficerAction)="rowitem">
          <div class="text-left">
            <b-link v-if="showLink" v-b-tooltip.left="'Copy Link'">
              <BaseIcon
                size="sm"
                name="link"
                class="ml-2 text-dark"
                @click.native.prevent="onCopyLink(rowitem.index)"
              />
            </b-link>
            <b-link v-if="showEdit" v-b-tooltip.hover.left="'Edit'">
              <BaseIcon
                noninteractive
                size="sm"
                name="pencil-alt"
                class="ml-2"
                @click.native.prevent="onClickEdit(rowitem.index)"
              />
            </b-link>
            <b-link
              v-if="rowitem.item.userInfo.isAccountActivated === false"
              v-b-tooltip.hover.left="'Resend Account Activation Email'"
            >
              <BaseIcon
                size="sm"
                noninteractive
                name="envelope"
                class="ml-2"
                @click.native.prevent="onClickEmail(rowitem.index)"
              />
            </b-link>
            <b-link
              v-if="rowitem.item.userInfo.isLocked === true"
              v-b-tooltip.hover.left="'Click to Unlock'"
            >
              <BaseIcon
                noninteractive
                size="sm"
                name="lock"
                class="ml-2 text-danger"
                @click.native.prevent="onClickUnlock(rowitem.index)"
              />
            </b-link>
          </div>
        </template>

        <template v-slot:cell(Action)="rowitem">
          <div :class="$style.cellIconBox" class="text-center">
            <b-link
              v-if="showCopy && rowitem.item.userURL !== null"
              v-b-tooltip.hover.left="'Copy'"
            >
              <BaseIcon
                noninteractive
                size="sm"
                name="copy"
                @click.native.prevent="onClickCopy(rowitem.index)"
              />
            </b-link>
          </div>
          <div :class="$style.cellIconBox" class="text-center">
            <b-link
              v-if="showEye"
              v-b-tooltip.hover.left="'View'"
              noninteractive
              @click.native.prevent="onClickEdit(rowitem.index)"
            >
              <BaseIcon noninteractive size="sm" name="eye" />
            </b-link>
          </div>

          <div :class="$style.cellIconBox" class="text-center">
            <b-link v-if="showEdit" v-b-tooltip.hover.left="'Edit'">
              <BaseIcon
                v-if="!!!rowitem.item.disableEdit"
                noninteractive
                size="sm"
                name="edit"
                @click.native.prevent="onClickEdit(rowitem.index)"
              />
            </b-link>
          </div>
          <div :class="$style.cellIconBox" class="text-center">
            <b-link
              v-if="rowitem.item.isAccountActivated === false && showEnvelope"
              v-b-tooltip.hover.left="'Resend Account Activation Email'"
            >
              <BaseIcon
                noninteractive
                size="sm"
                name="envelope"
                @click.native.prevent="onClickEmail(rowitem.index)"
              />
            </b-link>
          </div>
          <div :class="$style.cellIconBox" class="text-center">
            <b-link
              v-if="rowitem.item.isLocked === true"
              v-b-tooltip.hover.left="'Click to Unlock'"
            >
              <BaseIcon
                noninteractive
                size="sm"
                name="lock"
                class="ml-2 text-danger"
                @click.native.prevent="onClickUnlock(rowitem.index)"
              />
            </b-link>
          </div>
          <div
            v-if="isSupportAgent"
            :class="$style.cellIconBox"
            class="text-center"
          >
            <b-link v-b-tooltip.hover.left="'Reset Password'">
              <BaseIcon
                noninteractive
                size="sm"
                name="wrench"
                @click.native.prevent="onClickResetAccount(rowitem.item.userID)"
              />
            </b-link>
          </div>
        </template>
        <template v-slot:cell(Actions)="rowitem">
          <div class="text-center">
            <b-link v-if="showEdit" v-b-tooltip.hover.left="'Edit'">
              <BaseIcon
                noninteractive
                size="sm"
                name="edit"
                @click.native.prevent="onClickEdit(rowitem)"
              />
            </b-link>
            <b-link v-if="showdelete" v-b-tooltip.hover.left="'Delete'">
              <BaseIcon
                noninteractive
                size="sm"
                name="times-circle"
                class="ml-2"
                @click.native.prevent="onClickDelete(rowitem)"
              />
            </b-link>
          </div>
        </template>
        <template v-slot:cell(displayAddress)="rowitem">
          <p class="m-0 text-break">
            {{
              rowitem.item.addressLine1 +
                ' ' +
                (rowitem.item.addressLine2 || '') +
                ' ' +
                (rowitem.item.cityStateZip || '')
            }}
          </p>
        </template>

        <template v-slot:cell(DocumentLinkAction)="rowitem">
          <b-link
            v-if="rowitem.item.productId !== floodProductId"
            v-b-tooltip.hover.left="'Manage Documents'"
          >
            <BaseIcon
              noninteractive
              size="sm"
              name="folder-open"
              class="ml-2"
              @click.native.prevent="onClickFolder(rowitem.index)"
            />
          </b-link>
          <b-link
            v-if="
              InvoiceProducts.includes(rowitem.item.productId) &&
                rowitem.item.status === statusType.Completed
            "
          >
            <BaseIcon
              noninteractive
              size="sm"
              name="dollar-sign"
              class="ml-2"
              @click.native.prevent="onClickDollarSign(rowitem)"
            />
          </b-link>
          <b-link v-if="downloadReportProduct.includes(rowitem.item.productId)">
            <BaseIcon
              noninteractive
              size="sm"
              name="download"
              class="ml-2"
              @click.native.prevent="
                onClickDownload(rowitem.index, rowitem.item)
              "
            />
          </b-link>
        </template>

        <template v-slot:cell(actionEye)="rowitem">
          <div>
            <b-link
              v-if="showEye"
              v-b-tooltip.hover.left="'View'"
              noninteractive
              @click="info(rowitem.item, rowitem.index, $event.target)"
            >
              <BaseIcon noninteractive size="sm" name="eye" class="ml-2" />
            </b-link>
          </div>
        </template>
        <template v-slot:cell(action)="rowitem">
          <div :class="$style.cellIconBox" class="text-center">
            <b-link
              v-if="showEye"
              v-b-tooltip.hover.left="'View'"
              noninteractive
              @click.native.prevent="onClickEdit(rowitem.index)"
            >
              <BaseIcon noninteractive size="sm" name="eye" class="ml-2" />
            </b-link>
          </div>
          <div>
            <b-link v-if="showEdit" v-b-tooltip.hover.left="'Edit'">
              <BaseIcon
                noninteractive
                size="sm"
                name="pencil-alt"
                class="ml-2"
                @click.native.prevent="onClickEdit(rowitem.index)"
              />
            </b-link>
          </div>
        </template>

        <template v-slot:cell(actionRadio)="rowitem">
          <b-form-radio
            v-model="selected"
            name="some-radios"
            :value="rowitem.item.actionRadio.value"
            @click.native="onClickEdit(rowitem.item)"
          ></b-form-radio>
        </template>
        <template v-slot:cell(status)="rowitem">
          <div v-if="showStatus">
            <span v-if="rowitem.item.status === 'Active'">
              <BaseIcon
                noninteractive
                name="circle"
                :class="$style.statusSuccess"
              />
            </span>
            <span v-else>
              <BaseIcon
                noninteractive
                name="circle"
                :class="$style.statusFail"
              />
            </span>
          </div>
          <div v-else>
            {{ rowitem.item.status }}
            <b-link :class="$style.successCheck" class="my-auto text-warning">
              <BaseIcon
                v-if="rowitem.item.status === 'Pending'"
                size="sm"
                name="sync"
                class="ml-2"
                @click.native="
                  onClickPendingStatus(rowitem.item, rowitem.index)
                "
              />
            </b-link>
          </div>
        </template>

        <template
          v-for="field in fields"
          slot="overriddenURL"
          slot-scope="rowitem"
        >
          <div :key="field.key" class="d-flex">
            <b-form-input
              id="input"
              v-model="rowitem.item[field.key]"
              :state="null"
              size="sm"
            ></b-form-input>
            <b-link :class="$style.successCheck" class="my-auto text-success">
              <BaseIcon
                size="sm"
                name="check"
                class="ml-2"
                @click.native.prevent="onClickSave(rowitem)"
              />
            </b-link>
            <b-link :class="$style.resetInput" class="my-auto text-secondary">
              <BaseIcon
                size="sm"
                name="times"
                class="ml-2"
                @click.native.prevent="rowitem.item[field.key] = ''"
              />
            </b-link>
          </div>
        </template>

        <template v-slot:cell(voeactions)="rowitem">
          <b-row>
            <b-col class="text-center">
              <div :class="$style.cellIconBox" class="text-center">
                <b-link v-if="rowitem.item.status === 'New'" class="m-1">
                  <BaseIcon
                    noninteractive
                    size="sm"
                    name="eye-slash"
                    class="m-1 text-danger"
                  />
                </b-link>
                <b-link
                  v-if="rowitem.item.status === 'Failure'"
                  v-b-tooltip.hover.left="
                    'Error: ' + rowitem.item.severityMessage
                  "
                  class="m-1"
                >
                  <BaseIcon
                    noninteractive
                    size="sm"
                    name="eye-slash"
                    class="m-1 text-danger"
                    @click.native.prevent="viewPdfForOrderVoe(rowitem)"
                  />
                </b-link>
                <b-link v-if="rowitem.item.status === 'Cancelled'" class="m-1">
                  <BaseIcon
                    noninteractive
                    size="sm"
                    name="eye-slash"
                    class="m-1 text-danger"
                  />
                </b-link>
                <b-link v-if="rowitem.item.status === 'Failed'" class="m-1">
                  <BaseIcon
                    noninteractive
                    size="sm"
                    name="eye-slash"
                    class="m-1 text-danger"
                    @click.native.prevent="viewPdfForOrderVoe(rowitem)"
                  />
                </b-link>
                <b-link v-if="rowitem.item.status === 'InProgress'" class="m-1">
                  <BaseIcon
                    noninteractive
                    size="sm"
                    name="eye-slash"
                    class="m-1 text-danger"
                  />
                </b-link>
                <b-link
                  v-if="rowitem.item.status === 'Completed'"
                  v-b-tooltip.hover.left="'View'"
                  class="m-1"
                >
                  <BaseIcon
                    noninteractive
                    size="sm"
                    name="eye"
                    @click.native.prevent="viewPdfForOrderVoe(rowitem)"
                  />
                </b-link>
                <b-link
                  v-if="rowitem.item.status === 'Success'"
                  v-b-tooltip.hover.left="'View'"
                  class="m-1"
                >
                  <BaseIcon
                    noninteractive
                    size="sm"
                    name="eye"
                    @click.native.prevent="viewPdfForOrderVoe(rowitem)"
                  />
                </b-link>
              </div>

              <div :class="$style.cellIconBox" class="text-center">
                <b-link
                  v-if="rowitem.item.isReverifyVisible"
                  v-b-tooltip.hover.left="'Re-verify'"
                  class="m-1"
                >
                  <BaseIcon
                    noninteractive
                    size="sm"
                    name="copy"
                    @click.native.prevent="onReverifyOrderVoe(rowitem)"
                  />
                </b-link>
              </div>
              <div :class="$style.cellIconBox" class="text-center">
                <b-link
                  v-if="rowitem.item.isRefreshVisible"
                  v-b-tooltip.hover.left="'Refresh'"
                  class="m-1"
                >
                  <BaseIcon
                    noninteractive
                    size="sm"
                    name="sync"
                    @click.native.prevent="onRefreshOrderVoe(rowitem)"
                  />
                </b-link>
              </div>
            </b-col>
          </b-row>
        </template>
        <!-- Bureau Connection Actions -->
        <template v-slot:cell(bureauConnections)="rowitem">
          <b-row>
            <b-col class="text-center">
              <div md="auto" class="d-inline-block">
                <b-link v-if="showEdit" v-b-tooltip.hover.left="'Edit'">
                  <BaseIcon
                    noninteractive
                    size="sm"
                    name="edit"
                    @click.native.prevent="onClickEdit(rowitem)"
                  />
                </b-link>
              </div>
              <div md="auto" class="d-inline-block">
                <b-checkbox
                  v-model="rowitem.item.isActive"
                  name="bureauStatus"
                  class="checkIcon"
                  @change="onToggleBureauStatus(rowitem)"
                />
              </div>
              <div md="auto" class="d-inline-block" style="min-width:20px">
                <b-link
                  v-if="rowitem.item.isActive"
                  v-b-tooltip.hover.left="'Assign Customers'"
                  class="mt-1 mb-0 rounded-circle"
                >
                  <BaseIcon
                    noninteractive
                    size="sm"
                    name="plus-square"
                    :class="$style.headerPlus"
                    @click.native.prevent="onClickAssignConnection(rowitem)"
                  />
                </b-link>
              </div>
            </b-col>
          </b-row>
        </template>
        <!-- Bureau Connection end -->
        <template v-slot:cell(fplusActions)="rowitem">
          <b-row>
            <b-col v-if="!rowitem.item.flag360 || showInfo" class="text-center">
              <div md="auto" class="d-inline-block">
                <b-link v-if="showEdit" v-b-tooltip.hover.left="'Edit'">
                  <BaseIcon
                    noninteractive
                    size="sm"
                    name="edit"
                    @click.native.prevent="onClickEdit(rowitem)"
                  />
                </b-link>
              </div>
              <div md="auto" class="d-inline-block">
                <b-form-checkbox
                  v-model="rowitem.item.enabled"
                  name="fpPackageStatus"
                  class="checkIcon"
                  @change="onTogglePackageStatus(rowitem)"
                />
              </div>
              <div md="auto" class="d-inline-block" style="min-width:20px">
                <b-link
                  v-if="rowitem.item.enabled && !showInfo"
                  v-b-tooltip.hover.left="'Assign Customers'"
                  class="mt-1 mb-0 rounded-circle"
                >
                  <BaseIcon
                    noninteractive
                    size="sm"
                    name="plus-square"
                    :class="$style.headerPlus"
                    @click.native.prevent="onClickAssignPackage(rowitem)"
                  />
                </b-link>
                <b-link
                  v-else-if="showInfo"
                  v-b-tooltip.hover.left="'View Customers'"
                >
                  <BaseIcon
                    class="d-inline-block"
                    name="info-circle"
                    noninteractive
                    @click.native.prevent="viewCustomers(rowitem)"
                  />
                </b-link>
              </div>
            </b-col>
            <b-col v-else>
              <div>x360</div>
            </b-col>
          </b-row>
        </template>
        <!-- v-b-modal.infoModalid -->
        <template v-slot:cell(layoutActions)="rowitem">
          <b-row>
            <b-col class="text-center">
              <div md="auto" class="d-inline-block">
                <b-link
                  v-if="showEdit"
                  v-b-tooltip.hover.left="'Edit'"
                  class="m-1"
                >
                  <BaseIcon
                    noninteractive
                    size="sm"
                    name="edit"
                    @click.native.prevent="onClickEdit(rowitem)"
                  />
                </b-link>
              </div>
              <div md="auto" class="d-inline-block">
                <b-link
                  v-if="showdelete"
                  v-b-tooltip.hover.left="'Delete'"
                  class="m-1"
                >
                  <BaseIcon
                    noninteractive
                    size="sm"
                    name="times-circle"
                    class="ml-1"
                    @click.native.prevent="onClickDelete(rowitem)"
                  />
                </b-link>
              </div>
              <div md="auto" class="d-inline-block">
                <b-link v-if="showCopy" v-b-tooltip.hover.left="'Copy'">
                  <BaseIcon
                    noninteractive
                    size="sm"
                    name="copy"
                    @click.native.prevent="onClickCopy(rowitem)"
                  />
                </b-link>
              </div>
            </b-col>
          </b-row>
        </template>
        <template v-slot:cell(documentName)="rowitem">
          <div>
            <b-link
              :href="rowitem.item.filePath"
              class="m-1"
              target="_blank"
              @click.native.prevent="onClickDocumentName(rowitem)"
            >
              {{ rowitem.item.documentName }}
            </b-link>
          </div>
        </template>

        <template v-slot:cell(refItem)="rowItem">
          <b-link @click.prevent="onClickRefItem(rowItem.item)">
            {{
              rowItem.field.refValField
                ? rowItem.item[rowItem.field.refValField]
                : rowItem.value
            }}
          </b-link>
        </template>

        <template v-slot:cell(refItemList)="rowItem">
          <div v-if="Array.isArray(rowItem.item[rowItem.field.refValField])">
            <div
              v-for="(item, index) in rowItem.item[rowItem.field.refValField]"
              :key="index"
            >
              {{ item }}
            </div>
          </div>
          <div v-else>
            {{ rowItem.item[rowItem.field.refValField] }}
          </div>
        </template>

        <template v-slot:cell(index)="rowItem">
          {{ rowItem.index + 1 }}
        </template>

        <template v-slot:cell(ChildComponent)="rowItem">
          <component
            :is="rowItem.field.componentName"
            :list="rowItem.item.ChildComponent"
          />
        </template>
      </b-table>
    </div>
    <div
      v-if="items.length === 0"
      class="text-center py-2 border-bottom"
      :class="$style.noRecord"
    >
      No records found
    </div>

    <div v-if="showDollar" style="text-align:right;">
      <b-button
        slot="append"
        class="btn-secondary px-0"
        type="button"
        @click="costForBorrowerReportClicked"
      >
        &nbsp;&nbsp;
        <BaseIcon name="dollar-sign" />
        &nbsp;&nbsp;
      </b-button>
    </div>

    <b-row v-if="showdatatablefooter" class="row" align-h="between">
      <div class="col">
        <span :class="$style.statusFont">Showing {{pageFrom}}-{{pageTo}} of {{totalRows}} {{entryLabel}}</span>
      </div>
      <b-col md="4">
        <b-pagination
          v-model="selectedPage"
          limit="1"
          :total-rows="totalRows"
          :per-page="pageSize"
          aria-controls="my-table"
          align="right"
          class="pagination b-pagination pagination-sm"
          @click.native="$emit('paginationEvent', selectedPage)"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>
<style lang="scss" scoped>
/* stylelint-disable selector-pseudo-element-no-unknown, selector-class-pattern , no-descending-specificity, selector-max-type */
@import '@design';

::v-deep .table.b-table > thead > tr > [aria-sort='none'],
.table.b-table > tfoot > tr > [aria-sort='none'] {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='130' height='130' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' opacity='.3' d='M51 1l25 23 24 22H1l25-22zM51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e");
}

::v-deep .checkIcon .custom-control-label::after,
::v-deep .checkIcon .custom-control-label::before {
  top: 0.32rem;
  width: 0.75rem;
  height: 0.75rem;
  margin-left: 0.25rem;
  border-radius: 0.1rem;
}
::v-deep .custom-control-input:checked ~ .custom-control-label::before {
  background-color: $color-link-text;
  border-color: $color-link-text;
}

.right-align {
  text-align: end;
}

::v-deep .page-item.active .page-link,
::v-deep .page-item.disabled .page-link,
::v-deep .page-link {
  z-index: 0;
  color: $color-text;
  background-color: transparent;
  border: none;
}

::v-deep .page-item.active .page-link {
  color: $color-link-text;
}
</style>
<style lang="scss" module>
@import '@design';

table > thead {
  border-bottom: 3px solid $color-link-text;
}

table > thead > tr > th {
  font-size: $size-content-font;
  font-weight: 500;
  color: $color-text-gray;
  // text-align: center !important;
  background-color: $color-header-bg;
}

table > tbody > tr > td {
  padding: 0 0.45rem 0 0.45rem !important;
  overflow: hidden;
  font-size: $size-content-font;
  color: $color-text-gray;
  text-align: left;
  white-space: nowrap;
}
.noRecord {
  font-size: $size-content-font;
  background: #f2f2f2;
}
.bggrey {
  background: #f2f2f2;
}
.statusSuccess {
  color: $color-status-success !important;
}

.statusFail {
  color: $color-status-fail !important;
}
.status {
  margin: 0.625rem;
  font-size: $size-content-font;
  font-weight: $label-font-weight;
  color: $color-text-gray;
}

.semiBold {
  font-size: $size-content-font;
  font-weight: $label-font-weight;
}
.statusFont {
  font-size: $size-content-font;
  color: $color-text-gray;
}

.resetInput {
  position: relative;
  right: 45px;
}

.cellIconBox {
  position: relative !important;
  display: inline-block;
  width: 20px;
}
</style>
